import { sharedHeaders } from "../utils/constants"

const getDraftStatus = {
  "type": "endpoint",
  "method": "get",
  "title": "Get Draft Status",
  "path": "/v1/draft/{draft_id}/status",
  "description": "Get current status of a purchase draft",
  "request": {
    "headers": [
      ...sharedHeaders
    ],
    "pathParams": [
      {
        "key": "draft_id",
        "required": true,
        "type": "string",
        "description": "ID of the draft purchase to retrieve status for",
        "example": "lX8RkQmK49iPVWRt9gdc"
      }
    ]
  },
  "responses": {
    "200": {
      "description": "Successful response",
      "content": {
        "application/json": {
          "schema": {
            "type": "object",
            "properties": {
              "status": {
                "type": "string",
                "description": "Current status of the draft purchase",
                "example": "pending"
              },
              "paid_at": {
                "type": "number",
                "description": "Timestamp when the draft was paid, or null if not paid",
                "example": 1672531199000
              },
              "cancelled_at": {
                "type": "number",
                "description": "Timestamp when the draft was cancelled, or null if not cancelled",
                "example": null
              }
            },
            "required": [
              "status",
              "paid_at",
              "cancelled_at"
            ]
          }
        }
      }
    },
    "400": {
      "description": "Bad Request"
    },
    "401": {
      "description": "Unauthorized"
    },
    "500": {
      "description": "Internal Server Error"
    }
  },
  "components": {
    "schemas": {
      "DraftStatusParams": {
        "type": "object",
        "properties": {
          "draft_id": {
            "type": "string",
            "description": "ID of the draft purchase to retrieve status for",
            "example": "lX8RkQmK49iPVWRt9gdc"
          }
        },
        "required": [
          "draft_id"
        ]
      }
    }
  }
}

export { getDraftStatus }
